import { render, staticRenderFns } from "./NotAuthorized.vue?vue&type=template&id=2106ed3b"
import script from "./NotAuthorized.vue?vue&type=script&lang=js"
export * from "./NotAuthorized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports